/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Input for generating a log histogram.
*/
export class SearchLogsHistogramInput {
  /**
  * The list of resource IDs to query logs for.
  */
  'resourceIds': Array<string>;
  /**
  * Lucene syntax query string to filter logs. Examples: \"level:error\", \"eventName:CreateUser AND userIdentity.type:IAMUser\" 
  */
  'query'?: string;
  /**
  * The start date for the histogram time range.
  */
  'startDate': Date;
  /**
  * The end date for the histogram time range.
  */
  'endDate': Date;
  /**
  * The restore account ID to use for Athena queries. Required for customer-owned vaults (BYOV). For Eon-managed vaults, this field is optional and will be ignored. 
  */
  'restoreAccountId'?: string;
  /**
  * The S3 bucket in the restore account for Athena query output. Required for customer-owned vaults (BYOV). For Eon-managed vaults, this field is optional and will be ignored. 
  */
  'restoreBucket'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceIds",
      "baseName": "resourceIds",
      "type": "Array<string>",
      "format": "uuid"
    },
    {
      "name": "query",
      "baseName": "query",
      "type": "string",
      "format": ""
    },
    {
      "name": "startDate",
      "baseName": "startDate",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "endDate",
      "baseName": "endDate",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "restoreBucket",
      "baseName": "restoreBucket",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchLogsHistogramInput.attributeTypeMap;
  }

  public constructor() {
  }
}

